<template>
  <el-select
    filterable
    clearable
    v-model="id"
    :placeholder="placeholder"
    @change="change"
  >
    <el-option
      v-for="emp in emps"
      :key="emp.employeeId"
      :label="emp[label]"
      :value="emp[val]"
    >
      <span style="float: left">{{ emp.jobNumber }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{
        emp.employeeName
      }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      require: false,
      default() {
        return "";
      },
    },
    placeholder:{
        default:'请选择'
    },
    label:{
        default:'employeeName'
    },
    val:{
        default:'employeeId'
    }
  },
  data() {
    return {
      emps: [],
      id: this.value,
    };
  },
  mounted(){
    this.getEmployee()
  },
  methods: {
    change() {
      this.$emit("input", this.id);
      this.$emit("change", this.id);
    },
    async getEmployee() {
      const data = await this.$API.runListReport({
        number: "admin_employee_list",
      });
      this.emps = data;
    },
  },
};
</script>

<style>
</style>